<!-- src/components/ExpandedMenuItem.vue -->
<template>
  <div > 
    <div class="menu-item" v-if="item.show" :class="{ 'has-children': hasChildren(item), }"
      :style="{ paddingLeft: level > 1 ? (level * 20) + 'px' : '0px' }" @click="handleItemClick">
      <a class="item-name multiline-1" v-if="item.url" :href="item.url" target="_blank" @click="$emit('menu-click')">
        {{ item.name }}
      </a>
      <router-link class="item-name multiline-1" v-else :to="getRoutePath(item)" @click.native="$emit('menu-click')">
        {{ item.name }}
      </router-link>
    </div>

    <!-- 递归展开所有子级 -->
    <div v-if="hasChildren(item)" :class="['children-wrapper', `children-wrapper-level-${level + 1}`]">
      <ExpandedMenuItem v-for="(child, childIndex) in item.children" :key="`child-${childIndex}`" :item="child"
        :level="level + 1" @navigate="$emit('navigate', $event)" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ExpandedMenuItem',
  props: {
    item: {
      type: Object,
      required: true
    },
    level: {
      type: Number,
      default: 0
    }
  },
  emits: ['navigate'],
  methods: {
    hasChildren(item) {
      return item.children && item.children.length > 0;
    },
    getRoutePath(item) {
      
      // 根据实际情况调整路由路径生成逻辑
      if (item.id) {
        return `/category/${item.id}`;
      }
      return '/';
    },

    handleItemClick() {
      // 只有叶子节点才触发导航事件
      if (!this.hasChildren(this.item)) {
        this.$emit('navigate', this.item);
      }
    }
  }
};
</script>

<style scoped lang="scss">
.menu-item {
  box-sizing: border-box;


}

.children-wrapper {
  box-sizing: border-box;
  padding: 0 15px;

  .item-name{
    max-width: 100% !important;
  }
}
</style>